<template>
  <header aria-label="Cabecera principal" class="header dark:bg-darkblue hidden lg:flex border-b border-solid border-gray-10/50 dark:border-darkblue-600">
    <div class="brand w-full lg:w-72 lg:min-w-aside flex items-center justify-center select-none">
      <router-link :to="{ name: 'login' }" style="width: 200px">
        <base-logo 
          :filename="logo"
          :apiImage="true"
          alt="EdasNEO - Redirección al Dashboard" 
          class="max-h-13"
          data-v-step="0"
          />
      </router-link>
    </div>
    <nav 
      aria-label="Navegación de usuario"
      class="w-full flex items-center justify-between responsive-spacing-y px-10  select-none">
      <div class="flex items-center ml-auto">
        <div class="global-tools h-11 flex items-center space-x-2 mr-2">
          <div ref="dashboard" class="relative dropdown-area">
            <div class="relative" @click="gotoDashboard()">
              <base-button-icon name="dashboard" mode="core" ariaLabel="Redirigir al dashboard"/>
            </div>
          </div>
          <div
            ref="notifications"
            v-outside:click="{ exclude: ['notifications'], handler: closeNotifications }"
            class="relative dropdown-area"
            >
            <div class="relative" @click="toggleNotifications">
              <base-button-icon name="bell" mode="core" ariaLabel="Avisos y alertas"/>
              <span v-if="announcements !== null && announcements.length > 0 " class='badge badge-warning absolute top-2 right-0 z-20' :class="alreadyVisited ? 'badge-count-visited' : 'badge-count'"> {{ total }} </span>
              <span 
                v-show="actualFilterAlerts" 
                class='badge badge-warning absolute top-2 left-2 z-20 badge-count-visited' 
                v-popover:popover
                :tabindex="-1"
                >
                <base-icon name="filter" size="xs"/>
              </span>
              <el-popover
                :tabindex="-1"
                ref="popover"
                placement="bottom"
                width="320"
                trigger="hover"
                popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
                >
                <div>
                  <div v-if="actualFilterAlerts">
                    <div class="flex items-center justify-between">
                      <span class="text-lg">Filtro de cliente</span>
                      <base-button-icon
                        @click="resetAlertsFilter()"
                        name="cross"
                        iconSize="xs"
                        size="xs"
                        mode="primary-phantom"
                        class="ml-2 bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
                        ariaLabel="Eliminar filtro"
                      />
                    </div>
                    <div class="flex items-center justify-between">
                      <span>{{actualFilterAlerts.idCliente}} - {{actualFilterAlerts.Nombre}}</span>
                    </div>
                  </div>
                  <div v-else>
                    <span>Ningún filtro seleccionado</span>
                  </div>
                </div>    
              </el-popover>
            </div>
            <base-drop-down
              :isOpen="nots"
              position="bottom-right"
              customClass="w-50 z-2010imp"
              autoClose=true
              @toggle="toggleNotifications"
            >
              <div class="p-4">
                <div v-if="announcements != null && announcements.length > 0">
                  <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row" v-for="(announcement, index) in announcements" :key="index">
                      <div class="px-2 w-full  mb-2 lg:mb-0">
                        <router-link v-if="announcement.Enlace !== null" :to="{ name: announcement.Enlace }"
                            href="#" class="child w-full flex items-center  pr-4 h-8
                            hover:bg-primary-50 dark:hover:bg-darkblue-900 active:bg-primary-200 group animate-hover rounded">
                            <span
                              class="cover-subnav w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:border-darkblue-600"
                            >
                            <span class="link-name mr-4 truncate group-hover:text-primary-800 dark:text-gray-200">{{ announcement.Mensaje }}</span>
                          </span>
                        </router-link>
                        <button v-else-if="announcement.Accion !== null" @click="onclickAnnouncement(announcement.Accion)" 
                          class="child w-full flex items-center pr-4 h-8 cursor-pointer hover:bg-primary-50 dark:hover:bg-darkblue-900 active:bg-primary-200 group animate-hover rounded">
                          <span class="cover-subnav w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:border-darkblue-600">
                            <span class="link-name mr-4 truncate group-hover:text-primary-800 dark:text-gray-200">{{ announcement.Mensaje }}</span>
                          </span>
                        </button>
                        <span v-else class="cover-subnav w-full truncate overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:text-gray-200 dark:border-darkblue-600">{{ announcement.Mensaje }}</span>
                      </div>
                      <div class="px-2 mt-1 mb-2 lg:mb-0">
                          <span v-if="announcement.NumeroNotificaciones !== 0" class='badge badge-warning right-0 z-20 cart-count active:bg-primary-200'>
                            {{ announcement.NumeroNotificaciones }}
                          </span>
                      </div>
                  </div>
                </div>
                <div class="flex items-center justify-center w-32 dark:text-gray-200" v-else>
                  <p>{{$t('app.announcements_empty')}}</p>
                </div>
              </div>
            </base-drop-down>
          </div>
          <div
            v-if="false"
            ref="languageActive"
            class="relative dropdown-area z-2010"
            >
            <base-language
              :isOpen="languageActive" 
              @toggleLanguage="toggleLanguage" 
              :custom="['hover:bg-primary-50',{'bg-primary-50':languageActive}, 'dark:bg-darkblue-800', 'dark:hover:bg-darkblue-600', 'dark:text-darkblue-200']"
              />
            <base-drop-down
              v-outside:click="{ exclude: ['languageActive'], handler: closeLanguage }"
              autoClose=true
              :isOpen="languageActive"
              position="bottom-right"
              @toggle="toggleLanguage"
              >
                <ul class="p-1 divide-y divide-gray-50 dark:divide-gray-800 dark:border-darkblue-600 cursor-pointer">
                  <base-link-item-nav v-for="option in languagesOptions" :option="option" :key="option.value" />
                </ul>
            </base-drop-down>
          </div>
        </div>
        <div
          ref="avatar"
          class="relative dropdown-area z-2010"
        >
          <base-avatar
            :isOpen="avatar" 
            @toggleAvatar="toggleAvatar" 
            :custom="['hover:bg-primary-50',{'bg-primary-50':avatar}, 'dark:bg-darkblue-800', 'dark:hover:bg-darkblue-600', 'dark:text-darkblue-200']"
             />
          <base-drop-down
            v-outside:click="{ exclude: ['avatar'], handler: closeAvatar }"
            autoClose=true
            :isOpen="avatar"
            position="bottom-right"
            @toggle="toggleAvatar"
            >
              <ul class="p-1 divide-y divide-gray-100 dark:divide-gray-800 dark:border-darkblue-600 cursor-pointer">
                <li>
                  <button @click="changeDarkMode()" class="cursor-pointer group flex rounded-md items-center w-full px-2 py-2 text-sm bg-white dark:bg-darkblue dark:text-darkblue-200 lg:dark:bg-darkblue-900 hover:bg-primary-50 dark:hover:bg-darkblue hover:text-primary-800 active:bg-primary-100 dark:active:bg-darkblue-600 dark:focus:bg-darkblue-600 dark:focus:text-primary">
                    <base-icon name="darktheme" class="mr-2" :ariaHidden="true"/>
                    {{ mode }}
                  </button>
                </li>
                <base-link-item-nav v-for="option in userOptions" :option="option" :key="option.name" />
              </ul>
            </base-drop-down>
        </div>
      </div>
    </nav>
    <section>
      <help-dialog :dialogOpen="helpDialogOpen" @toggleDialog="toggleDialog" />
    </section>
    <!-- <license-dialog :dialogOpen="helpDialogOpen" @toggleDialog="toggleDialog" /> -->
  </header>
</template>

<script>
import { bus } from '@/main'
// import { i18n } from '@/i18n'
import { v4 as uuidv4 } from 'uuid'
import HelpDialog from '@/components/HelpDialog.vue' 
import { getApiBaseUrl, joinUrl } from '@/config/runtimeConfig'
// import LicenseDialog from '@/components/LicenseDialog.vue'

export default {
  name: 'header-core',
  components: {
    HelpDialog,
    // LicenseDialog,
  },
  mounted () {
    this.$root.$on('openNotesPatch', () => {
      this.showHelp()
    })
  },
  beforeDestroy () {
    this.$root.$off('openNotesPatch')
  },
  data: function () {
    var self = this
    return {
      helpDialogOpen: false,
      nots: false,
      alreadyVisited: false,
      total: 0,
      avatar: false,
      languageActive: false,
      productSelect: [
      ],
      configOptions: [
      ],
      languagesOptions: [
        {
          value: 'es-ES',
          name: 'Español',
          click: function () {
            self.setLocale('es-ES', bus)
          },
        }, 
        {
          value: 'en-EN',
          name: 'English',
          click: function () {
            self.setLocale('en-EN', bus)
          },
        },
      ],
      userOptions: [
        {
          icon: 'user',
          name: 'Mi perfil',
          click: function (store) {
            store.dispatch('auth/me', { navigate: true })
          }
        },
        {
          icon: 'help',
          name: 'Ayuda',
          click: function () {
            self.showHelp()
          }
        },
        {
          icon: 'logout',
          name: 'Cerrar sesión',
          click: function (store) {
            store.dispatch('auth/logout')
          }
        }
      ]
    }
  },
  computed: {
    actualFilterAlerts () {
      return this.$store.getters['app/idClienteFilterAlerts']
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      const pathBase = joinUrl(getApiBaseUrl(), 'api/empresas/getrecurso?hash=')
      const user = this.$store.getters['auth/user']

      // Personalizacion de logo
      if (user) {
        if (this.darkMode) {
          if (user.HashLogoDark) { 
            return pathBase + user.HashLogoDark 
          }
        } else {
          if (user.HashLogo) {
            return pathBase + user.HashLogo
          }
        }
      }

      if (this.darkMode) {
        return '/logos/edasneowhite.webp'
      }
      return '/logos/edasneo.webp'
    },
    announcements: function () {
      const announcements = []
      const value = this.$store.getters['app/getAnnouncementsList']
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.total = 0
      if (value != null) {
        value.forEach(element => {
          announcements.push(element)
          this.total += element.NumeroNotificaciones
        })
        // announcements.push({ url: '', Mensaje: 'Tienes notificaciones para expirar', NumeroNotificaciones: 122 })
      }
      return announcements
    },
    mode: function () {
      if (this.darkMode === true) {
        return 'Modo Claro'
      } else {
        return 'Modo Oscuro'
      }
    }
  },
  watch: {
    $route: 'routerChangeHandler'
  },
  methods: {
    resetAlertsFilter () {
      this.$store.dispatch('app/updateidClienteFilterAlerts', null)
      this.$store.dispatch('app/getAnnouncementsList')
    },
    onclickAnnouncement (action) {
      const data = { filters: [] }
      if (action === 'solicitudVacacionesError') {
        data.filters.push({ type: 'estadoDiasCortesiaAEATError', data: true })
        this.pushRouteNameAux(data, 'companies')
      } else if (action === 'consultaVacacionesError') {
        data.filters.push({ type: 'consultaDiasCortesiaAEATError', data: true })
        this.pushRouteNameAux(data, 'companies')
      } else if (action === 'empresasDesactivadas') {
        data.filters.push({ type: 'alertaEmpresaDesactivada', data: true })
        this.pushRouteNameAux(data, 'companies')
      } else if (action === 'cifsErrorHotfolder') {
        data.filters.push({ type: 'errorHotfolder', data: true })
        this.pushRouteNameAux(data, 'companies')
      } else if (action === 'cifsSinVigilarHotfolder') {
        data.filters.push({ type: 'sinVigilarHotfolder', data: true })
        this.pushRouteNameAux(data, 'companies')
      } else if (action === 'notificacionesEmailError') {
        data.filters.push({ type: 'notificacionesEmailError', data: true })
        this.pushRouteNameAux(data, 'notifications')
      } else if (action === 'notificacionesPresentacionesError') {
        data.filters.push({ type: 'notificacionesPresentacionesError', data: 2 })
        this.pushRouteNameAux(data, 'notifications')
      } else if (action === 'diligenciasError') {
        data.filters.push({ type: 'diligenciasError', data: true })
        this.pushRouteNameAux(data, 'procedings')
      } else if (action === 'notificacionesPeticionError') {
        data.filters.push({ type: 'notificacionesPeticionError', data: true })
        this.pushRouteNameAux(data, 'notifications')
      } else if (action === 'importacionesError') {
        data.filters.push({ type: 'tipoImportacionEstado', data: 2 })
        this.pushRouteNameAux(data, 'configurations/imports')
      } else if (action === 'clientesCertSAML2PorCaducar') {
        data.filters.push({ type: 'clientesCertSAML2PorCaducar', data: true })
        this.pushRouteNameAux(data, 'configurations/clients')
      } else if (action === 'clientesCertSAML2Caducados') {
        data.filters.push({ type: 'clientesCertSAML2Caducados', data: true })
        this.pushRouteNameAux(data, 'configurations/clients')
      } else if (action === 'sugerenciasPendientes') {
        data.filters.push({ type: 'sugerenciasPendientes', data: 2 })
        this.pushRouteNameAux(data, 'notifications')
      } else if (action === 'reincidenciaErrores') {
        data.filters.push({ type: 'reincidenciaErrores', data: true })
        this.pushRouteNameAux(data, 'notifications')
      } else {
        console.error('Acción inesperada: ' + action)
      }
    },
    pushRouteNameAux (data, name) {
      this.$router.push(
        {
          name: name, 
          params: { data: data }, 
          query: { _r: this.guid() } 
        })
    },
    showHelp: function () {
      this.toggleDialog()
    },
    toggleDialog: function () {
      this.helpDialogOpen = !this.helpDialogOpen
      if (!this.helpDialogOpen) {
        this.$store.dispatch('app/updatelastVisitedPatchNotes')
        this.$root.$emit('setControlFlagPatchNotes')
      } 
    },
    routerChangeHandler: function () {
      //
    },
    toggleNotifications: function () {
      this.nots = !this.nots
      this.alreadyVisited = true
    },
    closeNotifications: function () {
      this.nots = false
    },
    toggleAvatar: function () {
      this.avatar = !this.avatar
    },
    toggleLanguage () {
      this.languageActive = !this.languageActive
    },
    closeAvatar: function () {
      this.avatar = false
    },
    closeLanguage: function () {
      this.languageActive = false
    },
    changeDarkMode: function () {
      this.$store.commit('app/setDarkMode', !this.darkMode)
    },
    gotoDashboard: function () {
      const uuid = this.guid()
      this.$router.push({ name: 'dashboard', params: { id: uuid } })
    },
    guid: function () {
      return uuidv4()
    }
  }
}
</script>

<style lang="scss" scoped>
.w-aside-lg{
  width: 35rem;
}
.z-2010imp{
  z-index: 2010!important;
}
.open-user-menu {
  &:active {
    transform: scale(0.96);
  }
}
.animate-hover {
  @apply transition-colors duration-300;
}

.badge {
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
}

.label-warning[href],
.badge-warning[href] {
  background-color: #c67605;
}
#lblCartCount {
    font-size: 12px;
    background: #ff0000;
    color: #fff;
    padding: 0 5px;
    vertical-align: top;
    margin-left: -10px;
    margin-top: -15px;
}
.max-width-logo {
  width: 500px;
  max-width: 500px;
}

.cart-count {
    font-size: 16px;
    @apply bg-primary-800;
    color: #fff;
    padding: 5px 10px;
    vertical-align: center;
    margin-top: -15px;
}

.badge-count {
    font-size: 12px;
    background: #ED0000;
    color: #fff;
    padding: 0 5px;
    vertical-align: top;
    margin-left: -10px;
    margin-top: -15px;
}

.badge-count-visited {
    font-size: 12px;
    @apply bg-primary-800;
    @apply dark:bg-primary-500;
    color: #fff;
    padding: 0 5px;
    vertical-align: top;
    margin-left: -10px;
    margin-top: -15px;
}


</style>
